<template lang="pug">
  - $image_path = '@/assets/images/record/';
  .page-record
    CloseButton
    transition(name="slidein" appear)
      .frame
        .page-title
          p.page-title-text(ref="title"): img(src=`${$image_path}title.png`)
          .page-title-decoration-white(ref="titleDecoration"): img(src=`${$image_path}title_decoration_white.png`)
          .page-title-decoration-yellow(ref="titleDecoration"): img(src=`${$image_path}title_decoration_yellow.png`)
        .text: img(src=`${$image_path}text.png`)
        .record
          .debug-buttons
            button(@click="debugCounterStop") カウンターストップ
            button(@click="debugResetRecord") 成績をリセット（レベル0）
            button(@click="debugLevelSet(1)") レベル1
            button(@click="debugLevelSet(2)") レベル2
            button(@click="debugLevelSet(3)") レベル3
            button(@click="debugLevelSet(4)") レベル4
            button(@click="debugLevelSet(5)") レベル5
            button(@click="debugLevelSet(6)") レベル6
            button(@click="debugLevelSet(7)") レベル7
          .record-hight-score
            p.score-number.number-sprite-s-yellow(
              v-for="num in highScoreList"
              :class="`number-${num}`"
            )
          .record-total-happy-turn
            p.score-number.number-sprite-s-yellow(
              v-for="num in totalHappyTurnList"
              :class="`number-${num}`"
            )
          .record-list
            ul.record-list-items
              li.record-list-item(v-for="(item, index) in recordList")
                p.record-list-item-medal(ref="recordMedal"): img(src=`${$image_path}image_medal.png`)
                p.record-list-item-text(ref="recordText"): img(:src="require(`@/assets/images/record/text_record_0${index + 1}.png`)")
              li.record-list-item.is-close
                p.record-list-item-text: img(src="@/assets/images/record/text_record_07_close.png")
            .record-list-board: img(src=`${$image_path}text_record_list.png`)
</template>

<script>
import { TimelineMax, TweenMax } from 'gsap';
import _ from 'lodash';

import CookieData from '@/assets/js/CookieData';
import CountUp from '@/assets/js/CountUp';
import SoundController from '@/assets/js/SoundController';
import Utils from '@/assets/js/Utils';
import GameManager from '@/assets/js/game/GameManager';

import CloseButton from '@/components/CloseButton';

export default {
  name: 'Record',
  components: {
    CloseButton
  },
  data() {
    return {
      timeline: null,
      hishScoreCounter: null,
      totalHappyTurnCounter: null,
      highScoreList: [0],
      totalHappyTurnList: [0]
    };
  },
  computed: {
    recordList() {
      return GameManager.recordList;
    }
  },
  beforeDestroy() {
    SoundController.stopAll();
    this.hishScoreCounter.stop();
    this.totalHappyTurnCounter.stop();
    if (this.timeline) this.timeline.pause();
  },
  mounted() {
    SoundController.play('bgm_out_game');
    this.countUp();
    this.startTimelineAnimation();
  },
  methods: {
    countUp() {
      this.hishScoreCounter = new CountUp(CookieData.highScore, count => {
        SoundController.play('se_add_score');
        this.highScoreList = Utils.getNumberToList(count);
      });
      this.totalHappyTurnCounter = new CountUp(
        CookieData.totalHappyTurn,
        count => {
          SoundController.play('se_add_score');
          this.totalHappyTurnList = Utils.getNumberToList(count);
        }
      );
    },
    startTimelineAnimation() {
      this.timeline = new TimelineMax();
      _.forEach(this.recordList, (isActive, index) => {
        if (isActive) {
          const medal = this.$refs.recordMedal[index];
          const text = this.$refs.recordText[index];
          const onComplete = () => SoundController.play('se_show_result_value');
          this.timeline
            .to(text, { scale: 1.3, opacity: 0.7, duration: 0.25 })
            .to(text, {
              scale: 1,
              opacity: 1,
              duration: 0.2,
              onComplete: onComplete
            })
            .to(medal, { scale: 1.5, opacity: 0.7, duration: 0.35 }, '-=0.2')
            .to(medal, { scale: 1, opacity: 1, duration: 0.3 }, '-=0.2');
        }
      });
    },
    debugCounterStop() {
      CookieData.counterStop();
      window.location.reload();
    },
    debugResetRecord() {
      CookieData.resetRecord();
      window.location.reload();
    },
    debugLevelSet(num) {
      CookieData.setLevel(num);
      window.location.reload();
    }
  }
};
</script>

<style scoped lang="scss">
.page-record {
  height: 100%;
  background: image-url('common/bg_castle_thin.png') no-repeat
    map-get($primary_color, 'thin_grass');
  background-size: 100% auto;
  .frame {
    background: image-url('record/image_frame.png') no-repeat #fff7d4;
    background-size: 100% auto;
  }
  .page-title {
    top: vw(135);
    left: vw(191.5);
    width: vw(897);
    &-decoration {
      &-white {
        top: vw(-10);
        left: vw(95);
        width: vw(722);
      }
      &-yellow {
        top: vw(-77);
        left: vw(20);
        width: vw(858);
      }
    }
  }
  .text {
    width: vw(975);
    margin: 0 auto;
    padding-top: vw(356);
  }
  .record {
    .debug-buttons {
      position: absolute;
      top: vw(30);
      left: vw(30);
      z-index: 2;
    }
    &-hight-score {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: absolute;
      top: vw(500);
      right: vw(150);
      z-index: 1;
      .score {
        &-number {
          margin-left: vw(-18);
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    &-total-happy-turn {
      display: flex;
      justify-content: flex-end;
      align-items: flex-end;
      position: absolute;
      top: vw(650);
      right: vw(150);
      z-index: 1;
      .score {
        &-number {
          margin-left: vw(-18);
          &:first-child {
            margin-left: 0;
          }
        }
      }
    }
    &-list {
      position: relative;
      width: vw(1100);
      margin: vw(60) auto 0;
      &-items {
        position: absolute;
        top: vw(350);
        left: 0;
        width: 100%;
      }
      &-item {
        position: relative;
        width: vw(1040);
        margin: vw(15) auto 0;
        &:first-child {
          margin-top: 0;
        }
        &.is-close {
          .record-list-item-text {
            opacity: 1;
          }
        }
        &-medal {
          position: absolute;
          top: vw(-31);
          left: vw(-22);
          width: vw(182);
          z-index: 1;
          opacity: 0;
        }
        &-text {
          opacity: 0;
        }
      }
    }
  }
  .number-sprite-s-yellow {
    background-image: image-url('game/number_s_spritesheet_yellow.png');
  }
}
</style>
